const defaultTemplateData = {
  micrositeTemplateType: "",
  branding: {
    websiteLogoUrl: "https://res.cloudinary.com/gozade/image/upload/v1766143987/image/image_68d5151acc0789d01beb7fc2/image/ip61rtapyscxr5qsshck.svg",
    websiteColorCode: "#1E3A8A",
    textColorCode: "#FFF"
  },
  headerSection: {
    headerTitle: "GMES & Africa",
    headerDescription: "Developing Earth Observation solutions for Environmental Monitoring Increasing access to Earth Observation data",
    headerImageUrl: "https://res.cloudinary.com/gozade/image/upload/v1766144063/image/image_68d5151acc0789d01beb7fc2/image/mlk7azopgifp2k8brhrg.png"
  },
  headerSectionTwo: {
    headerSectionTwoTitle: "Earth Observation Data - The Explosion",
    headerSectionTwoDescription: "Recent years have seen an unprecedented increase in the volume and quality of satellite images for Earth Observation. Simultaneously technological advancements have improved access and processing capability. At ICPAC the GMES & Africa project takes advantage of EO data and technology to develop solutions for monitoring, planning, management of the Environment and food-security early warning."
  },
  missionTimeLineSection: {
    missionTimeLineTitle: "Mission Timeline",
    missionTimeLineDescription: "To explore space, conduct scientific research, and develop technologies that expand human knowledge and capabilities.",
         missionTimeLineSectionDetails: [
    {
      missionTimeLineSectionTitle: "Maputo",
      missionTimeLineSectionDescription: "Before the 8th EUMETSAT User Forum in Africa, the European and African partners of the Lisbon Process met in Accra to define the Terms of Reference for this Process and the thematic areas to be included. The structure of the technical coordination and development of the GMES & Africa Action Plan was defined, including the consultation process by experts and Africa users. The Joint Implementation Group of the 8th EU-Africa Partnership will provide political supervision and guidance of the Process.",
      missionTimeLineSectionImageUrl: "https://res.cloudinary.com/gozade/image/upload/v1766144118/image/image_68d5151acc0789d01beb7fc2/image/kxgdhbbmvse2x3senlgo.png",
      missionTimeLineStartDate: "October 2024",
      missionTimeLineEndDate: "January 2027"
    },
    {
      missionTimeLineSectionTitle: "Maputo",
      missionTimeLineSectionDescription: "Before the 8th EUMETSAT User Forum in Africa, the European and African partners of the Lisbon Process met in Accra to define the Terms of Reference for this Process and the thematic areas to be included. The structure of the technical coordination and development of the GMES & Africa Action Plan was defined, including the consultation process by experts and Africa users. The Joint Implementation Group of the 8th EU-Africa Partnership will provide political supervision and guidance of the Process.",
      missionTimeLineSectionImageUrl: "https://res.cloudinary.com/gozade/image/upload/v1766144118/image/image_68d5151acc0789d01beb7fc2/image/kxgdhbbmvse2x3senlgo.png",
      missionTimeLineStartDate: "October 2024 ",
      missionTimeLineEndDate: "January 2025"
    }
  ],
    },
  newsFeedSection: {
    newsFeedTitle: "News Feed",
    newsFeedDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla.",
        newsFeedSectionDetails: [
    {
      newsFeedSectionTitle: "From Forests to Future: The Power of Native Reforestation in Supporting Kenya's Local Climate",
      newsFeedSectionDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla.",
      newsFeedSectionImageUrl: "https://res.cloudinary.com/gozade/image/upload/v1766144063/image/image_68d5151acc0789d01beb7fc2/image/mlk7azopgifp2k8brhrg.png",
      newsFeedSectionLink: ""
    },
    {
      newsFeedSectionTitle: "Pursuing Sustainable Development Goal 15: Progress and Challenges in Protecting Life on Land",
      newsFeedSectionDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla.",
      newsFeedSectionImageUrl: "https://res.cloudinary.com/gozade/image/upload/v1766144063/image/image_68d5151acc0789d01beb7fc2/image/mlk7azopgifp2k8brhrg.png",
      newsFeedSectionLink: ""
    },
    {
      newsFeedSectionTitle: "A Comprehensive Approach to Monitoring Reforestation initiatives in the Eastern Africa Region",
      newsFeedSectionDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla.",
      newsFeedSectionImageUrl: "https://res.cloudinary.com/gozade/image/upload/v1766144118/image/image_68d5151acc0789d01beb7fc2/image/kxgdhbbmvse2x3senlgo.png",
      newsFeedSectionLink: ""
    },
    {
      newsFeedSectionTitle: "A Comprehensive Approach to Monitoring Reforestation initiatives in the Eastern Africa Region",
      newsFeedSectionDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla.",
      newsFeedSectionImageUrl: "https://res.cloudinary.com/gozade/image/upload/v1766144118/image/image_68d5151acc0789d01beb7fc2/image/kxgdhbbmvse2x3senlgo.png",
      newsFeedSectionLink: ""
    }
  ],
  },
  footerSection: {
    footerDescription: "The African Space Agency is the primary point of contact for Africa's cooperation with Europe and other international partners. ",
    socialLinks: {
      twitter: "https://twitter.com/spaceagency",
      facebook: "https://facebook.com/spaceagency",
      instagram: "https://instagram.com/spaceagency",
      linkedIn: "https://linkedin.com/company/spaceagency",
      youtube: "https://youtube.com/spaceagency"
  },

    footerEmail: "info@africanspaceagency.org",
    footerAddress: "Egypt Space City, New Cairo Governate, Egypt"
  
  }
};

export default defaultTemplateData;